import React from "react";

export const RespContext = React.createContext();
export const RespDispatchContext = React.createContext();



function RespProvider({children}) {
    const [state,setstate] = React.useState(undefined)
    return(
        <RespContext.Provider value={state}>
            <RespDispatchContext.Provider value={setstate} >
                {children}
            </RespDispatchContext.Provider>
        </RespContext.Provider>
    )
}

export {RespProvider};
